export default {
    cannot_edit_past_reservations: 'You cannot edit past reservations.',
    minimum_time_difference_to_edit: 'You cannot edit reservations scheduled in less than one hours.',
    invalid_availability_offer: 'Service has invalid availability.',
    unavailable_for_rescheduling: 'Service cannot be rescheduled.',
    not_permissioned: 'You are not allowed to edit this service.',
    not_found: 'Service is not found.',
    time_must_be_in_the_past: 'Reservation time must be in the past.',
    mins_ahead_60:
        'This reservation cannot be changed. Minimum difference for changing status has to be at least 60 minutes ahead.',
    mins_ahead_20:
        'This reservation cannot be changed. Minimum difference for changing status has to be at least 20 minutes ahead.',
    time_zone_issue: 'Please check time on your device. It is not compatible with servers time.',
    minimum_5: 'It is not possible to select an option less than 5 minutes',
    overlap_too_large: 'The number of selected minutes is too large. Please choose a smaller number of minutes.',
    unavailable_for_allowing_overlap: 'It is not possible to finish this reservation earlier.',
}
